import { ModernTemplate } from './ModernTemplate';
import { MinimalTemplate } from './MinimalTemplate';
import { ProfessionalTemplate } from './ProfessionalTemplate';
import { CreativeTemplate } from './CreativeTemplate';

export const templates = [
  {
    id: 'modern',
    name: 'Modern',
    component: ModernTemplate,
    preview: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?auto=format&fit=crop&q=80&w=200'
  },
  {
    id: 'minimal',
    name: 'Minimal',
    component: MinimalTemplate,
    preview: 'https://images.unsplash.com/photo-1586281380117-8c2eadb2d094?auto=format&fit=crop&q=80&w=200'
  },
  {
    id: 'professional',
    name: 'Professional',
    component: ProfessionalTemplate,
    preview: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?auto=format&fit=crop&q=80&w=200'
  },
  {
    id: 'creative',
    name: 'Creative',
    component: CreativeTemplate,
    preview: 'https://images.unsplash.com/photo-1586281380117-8c2eadb2d094?auto=format&fit=crop&q=80&w=200'
  }
];